import { gql } from "@apollo/client";

export const INICIAR_SESION = gql`
  mutation INICIAR_SESION($input: InputLogin) {
    iniciarSesion(input: $input) {
      session
      error
      MenuSideBar {
        title
        path
        icon
      }
    }
  }
`;
